import env from '@polleverywhere/core/lib/env'
import { initializeTypekit } from '@polleverywhere/viz-utils/lib/load-custom-font'

// catch rejection so we don't have a uncaught exception
initializeTypekit(env.get('typekit_id')).catch(() => {})
